// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__1jGlU","layout-body":"style_layout-body__Jm0EC"};